<div>
  <p class="text-white text-center">Autenticando ...</p>
</div>
